import { interpretMessage } from '../../utils/interpret-message/interpretMessage';
import { CustomMessageOptions } from '../type';

const MESSAGE = 'Must be at most {{length}} characters long';

export function createMaxLengthValidator(
    length: number, msgOptions?: CustomMessageOptions,
): (val?: string) => string | boolean {
    return (val?: string) => {
        // not checking undeinfed or null they will be part of required
        if (val == null || val?.length <= length) {
            return true;
        }

        const message = msgOptions?.customMsg || MESSAGE;
        const params = {
            field: msgOptions?.fieldName || 'field',
            length,
        };

        return interpretMessage(message, params);
    };
}
